import React from 'react';
import { Select, Form } from 'grab-ui';
import {
  CHANNEL_GROUPS,
  CHANNEL_GROUP_DISPLAY_NAMES,
  CHANNEL_GROUP_CHANNELS,
  CHANNEL_DISPLAY_NAMES,
} from 'omega-rtc/constants/ucd';
import tridentIcon from 'img/ucd_channelgroup_trident.svg';
import pmIcon from 'img/ucd_channelgroup_pm.svg';
import hedwigIcon from 'img/ucd_channelgroup_hedwig.svg';
import salesforceIcon from 'img/ucd_channelgroup_salesforce.svg';
import feedIcon from 'img/ucd_channelgroup_feed.svg';
import _ from 'lodash';

type Props = {
  form: any,
  channelGroup: string,
  initialValues: any,
  hideOptions: Array<string>,
  selectProps: any,
};

const channelGroupIconMapping = {
  [CHANNEL_GROUPS.pm]: pmIcon,
  [CHANNEL_GROUPS.hedwig]: hedwigIcon,
  [CHANNEL_GROUPS.trident]: tridentIcon,
  [CHANNEL_GROUPS.feed]: feedIcon,
  [CHANNEL_GROUPS.salesforce]: salesforceIcon,
};

const AddCampaignTypeForm = (props: Props) => {
  const { hideOptions, selectProps } = props;
  const showLabel = !hideOptions || !hideOptions.includes('channelGroupTitle');
  const showChannelType = !hideOptions || !hideOptions.includes('channelType');
  const showChannelGroup =
    !hideOptions || !hideOptions.includes('channelGroup');
  return (
    <div
      style={{
        marginTop: !hideOptions ? '40px' : 0,
        marginBottom: !hideOptions ? '36px' : 0,
      }}
    >
      {showChannelGroup && (
        <div>
          {showLabel && (
            <div style={{ fontWeight: 'bold' }}>Selected Channel Group</div>
          )}
          <div
            style={{
              display: 'flex',
              border: !hideOptions ? '1px solid #E8E8E8' : '0px solid white',
              borderRadius: '6px',
              marginTop: !hideOptions ? '11px' : 0,
              padding: !hideOptions ? '16px 14px' : 0,
              alignItems: 'center',
            }}
          >
            <img
              src={_.get(channelGroupIconMapping, props.channelGroup)}
              style={{ width: '48px', height: '48px' }}
              alt={props.channelGroup}
            />
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                marginLeft: '14px',
              }}
            >
              {_.get(CHANNEL_GROUP_DISPLAY_NAMES, props.channelGroup)}
            </div>
          </div>
        </div>
      )}
      {showChannelType && (
        <div style={{ marginTop: '24px' }}>
          <Form.Item>
            <div style={{ marginBottom: '11px', fontWeight: 'bold' }}>
              <span style={{ color: 'red', marginRight: '3px' }}>*</span>Channel
              Type
            </div>
            {props.form.getFieldDecorator('channelType', {
              rules: [
                {
                  required: 'true',
                },
              ],
              initialValue: _.get(props, 'initialValues.channelType'),
            })(
              <Select
                mode={'multiple'}
                placeholder={'Select Channel Type'}
                {...(selectProps || {})}
              >
                {_.get(CHANNEL_GROUP_CHANNELS, props.channelGroup, []).map(
                  channel => (
                    <Select.Option value={channel} key={channel}>
                      {_.get(CHANNEL_DISPLAY_NAMES, channel)}
                    </Select.Option>
                  ),
                )}
              </Select>,
            )}
          </Form.Item>
        </div>
      )}
    </div>
  );
};

export default AddCampaignTypeForm;
